module.exports = __webpack_public_path__ + "site/img/127.6ed8c316.jpg";